/* 🧠 REDUX */
import { store } from "../../../../Redux/Store";
import { LogOut } from "../../../../Redux/Actions";

/* 🎨 STYLES */
import { Container, ContainerIcon, SideBarIcon} from "./styles";

/* 🔧 UTILS */
import { isValidaProp } from "../../../../util/validate";

const SideBarLogout = (props) => {
    const Icon = isValidaProp(props.Icon) ? props.Icon : null;
    const Leave = ()=>{
        store.dispatch(LogOut())
    }    
    return(
        <Container>
            <ContainerIcon onClick={()=> Leave()}>
                {Icon ? <SideBarIcon src={Icon}/> : <></>}
            </ContainerIcon>
        </Container>
    )
}

export default SideBarLogout;